import { Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { OWN_CRUMB, trailFor } from './breadcrumbs';
import { t } from '../i18n/i18n';

const icon = (name) => ({ '--icon': `url(/icons/${name}.svg)` });

/**
 * The trail above every page — N84, live's "⌂ › Dashboard". Home, then each
 * level as a link, the page itself as plain text. The names come from the
 * nav and the section tabs (see breadcrumbs.js), so it can't disagree with
 * them.
 */
export default function Breadcrumb() {
  const { pathname } = useLocation();
  if (OWN_CRUMB(pathname)) return null;

  const trail = trailFor(pathname);

  return (
    <nav className="crumbs" aria-label={t('Breadcrumb')}>
      <Link to="/dashboard" className="crumbs__home" aria-label={t('Home')}>
        <span className="icon crumbs__home-icon" style={icon('crumb-home')} />
      </Link>
      {trail.map((step, i) => {
        const last = i === trail.length - 1;
        return (
          <Fragment key={`${step.to}-${step.label}`}>
            <span className="icon crumbs__sep" style={icon('crumb-chevron')} aria-hidden="true" />
            {last ? (
              <span className="crumbs__current" aria-current="page">
                {t(step.label)}
              </span>
            ) : (
              <Link to={step.to} className="crumbs__link">
                {t(step.label)}
              </Link>
            )}
          </Fragment>
        );
      })}
    </nav>
  );
}
